var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrophy({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: "1em",
    viewBox: "0 0 512 512",
    width: "1em",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m152.862 232.073c-1.504 0-3.024-.439-4.359-1.353-52.14-35.707-88.387-95.4-99.446-163.771-1.528-9.441 1.149-19.029 7.343-26.305 6.179-7.259 15.188-11.422 24.719-11.422h47.987c4.267 0 7.726 3.459 7.726 7.726s-3.459 7.726-7.726 7.726h-47.987c-4.994 0-9.715 2.181-12.952 5.985-3.253 3.821-4.658 8.859-3.855 13.821 10.387 64.216 44.256 120.161 92.923 153.491 3.521 2.41 4.42 7.219 2.009 10.74-1.497 2.185-3.919 3.362-6.382 3.362z",
    fill: "#fbc700"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m359.138 232.073c-2.464 0-4.885-1.176-6.382-3.361-2.411-3.521-1.512-8.33 2.009-10.74 48.666-33.33 82.536-89.275 92.923-153.49.803-4.963-.603-10.001-3.856-13.822-3.237-3.804-7.958-5.985-12.952-5.985h-47.987c-4.267 0-7.726-3.459-7.726-7.726s3.459-7.726 7.726-7.726h47.987c9.531 0 18.541 4.163 24.719 11.421 6.194 7.277 8.87 16.865 7.343 26.306-11.06 68.372-47.307 128.064-99.447 163.771-1.333.913-2.853 1.352-4.357 1.352z",
    fill: "#fbc700"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m311.829 393.653c-17.324-16.6-29.327-40.343-34.023-64.334l-4.487-22.922c-5.332 2.225-11.18 3.462-17.32 3.462s-11.987-1.237-17.32-3.462l-4.487 22.922c-4.696 23.991-16.699 47.734-34.023 64.334z",
    fill: "#ffe02f"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m311.829 393.653c-17.324-16.6-29.327-40.343-34.023-64.334l-4.487-22.922c-5.332 2.225-11.18 3.462-17.32 3.462s-11.987-1.237-17.32-3.462l-4.487 22.922c-4.696 23.991-16.699 47.734-34.023 64.334z",
    fill: "#ffe02f"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m258.108 309.806c-.699.032-1.401.053-2.108.053-6.14 0-11.987-1.237-17.319-3.462l-4.487 22.923c-4.696 23.991-16.699 47.734-34.023 64.334h31.981c11.883-16.6 20.115-40.343 23.336-64.334z",
    fill: "#fbc700"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m256 276.269c-15.815 0-30.951-2.902-44.914-8.188 1.676 23.35 21.137 42.808 44.914 42.808 23.778 0 43.239-19.457 44.914-42.808-13.963 5.286-29.099 8.188-44.914 8.188z",
    fill: "#fbc700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m256 276.269c-15.815 0-30.951-2.902-44.914-8.188 1.676 23.35 21.137 42.808 44.914 42.808 23.778 0 43.239-19.457 44.914-42.808-13.963 5.286-29.099 8.188-44.914 8.188z",
    fill: "#fbc700"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m242.615 275.562c-10.987-1.155-21.559-3.706-31.53-7.48 1.676 23.35 21.137 42.808 44.914 42.808 4.565 0 8.969-.723 13.121-2.048-13.444-5.984-23.527-18.52-26.505-33.28z",
    fill: "#ffa812"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m256 30.231h-126.894v120.176c0 70.081 56.812 126.893 126.893 126.893s126.894-56.812 126.894-126.893v-120.176z",
    fill: "#ffe02f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m256 30.231h-126.894v120.176c0 70.081 56.812 126.893 126.893 126.893s126.894-56.812 126.894-126.893v-120.176z",
    fill: "#ffe02f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m174.021 150.406v-120.175h-44.914v120.176c0 70.081 56.812 126.893 126.893 126.893 7.663 0 15.168-.679 22.457-1.981-59.37-10.603-104.436-62.495-104.436-124.913z",
    fill: "#fbc700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m344.574 392.623h-177.148c-5.843 0-10.579 4.737-10.579 10.579v21.711h198.307v-21.711c-.001-5.842-4.737-10.579-10.58-10.579z",
    fill: "#fbc700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m240.053 392.623h-72.628c-5.843 0-10.579 4.737-10.579 10.579v21.711h72.628v-21.711c0-5.842 4.736-10.579 10.579-10.579z",
    fill: "#ffa812"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m129.106 27.473v33.069h253.787v-33.069h-126.893z",
    fill: "#fbc700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m129.106 27.473v33.069h253.787v-33.069h-126.893z",
    fill: "#fbc700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m129.106 27.473v33.069h44.915v-33.069h-22.458z",
    fill: "#ffa812"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m385.262 0h-258.525c-5.843 0-10.58 4.737-10.58 10.58v9.071c0 5.843 4.737 10.58 10.58 10.58h258.525c5.843 0 10.579-4.737 10.579-10.58v-9.071c.001-5.843-4.736-10.58-10.579-10.58z",
    fill: "#ffe02f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m385.262 0h-258.525c-5.843 0-10.58 4.737-10.58 10.58v9.071c0 5.843 4.737 10.58 10.58 10.58h258.525c5.843 0 10.579-4.737 10.579-10.58v-9.071c.001-5.843-4.736-10.58-10.579-10.58z",
    fill: "#ffe02f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m163.031 19.651v-9.071c0-5.843 4.737-10.58 10.579-10.58h-46.873c-5.843 0-10.579 4.737-10.579 10.58v9.072c0 5.843 4.737 10.579 10.579 10.579h46.873c-5.842 0-10.579-4.737-10.579-10.58z",
    fill: "#fbc700"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m382.893 445.405c0-12.454-10.097-22.551-22.551-22.551h-211.053c-12.455 0-22.551 10.097-22.551 22.551v38.425h256.156v-38.425z",
    fill: "#ffe02f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m221.916 422.854h-72.628c-12.455 0-22.551 10.096-22.551 22.551v38.426h72.628v-38.426c0-12.455 10.097-22.551 22.551-22.551z",
    fill: "#fbc700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m385.262 481.77h-258.525c-5.843 0-10.58 4.737-10.58 10.58v9.071c0 5.843 4.737 10.579 10.58 10.579h258.525c5.843 0 10.579-4.737 10.579-10.579v-9.071c.001-5.844-4.736-10.58-10.579-10.58z",
    fill: "#fbc700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m188.786 501.42v-9.071c0-5.843 4.737-10.579 10.579-10.579h-72.628c-5.843 0-10.579 4.737-10.579 10.579v9.071c0 5.843 4.737 10.579 10.579 10.579h72.628c-5.843.001-10.579-4.736-10.579-10.579z",
    fill: "#ffa812"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrophy);
export default __webpack_public_path__ + "static/media/trophy.6067415e6cd6b7f41c850609d7576da5.svg";
export { ForwardRef as ReactComponent };